// src/features/fourlink-config/utils/storage/horarioStorage.js

import { isPlainObject, firstNonEmpty, ensureArray } from '../helpers/filters';
import { SCHEDULES_STORAGE_KEY } from '../helpers/constants';

export const normalizeTurnoId = (value) => {
  if (value === undefined || value === null) return null;
  return String(value);
};

export const normalizeHorarioEntry = (entry, index = 0) => {
  if (entry === null || entry === undefined) {
    return {
      id: `horario-${index}`,
      name: '',
      startTime: '',
      endTime: '',
      isCustom: false,
    };
  }

  if (typeof entry === 'string') {
    const trimmed = entry.trim();
    return {
      id: `horario-${index}`,
      name: trimmed,
      startTime: '',
      endTime: '',
      isCustom: false,
    };
  }

  if (!isPlainObject(entry)) {
    return {
      id: `horario-${index}`,
      name: '',
      startTime: '',
      endTime: '',
      isCustom: false,
    };
  }

  const idCandidate = firstNonEmpty(
    entry.id,
    entry.ID,
    entry.uuid,
    entry.key,
    entry.codigo,
    entry.codigo_horario,
    entry.nombre,
    entry.name,
  );
  const nombreCandidate = firstNonEmpty(entry.name, entry.nombre, entry.titulo, entry.descripcion);
  const inicioCandidate = firstNonEmpty(
    entry.startTime,
    entry.hora_inicio,
    entry.horaInicio,
    entry.horainicio,
    entry.desde,
  );
  const finCandidate = firstNonEmpty(
    entry.endTime,
    entry.hora_final,
    entry.horaFin,
    entry.horafin,
    entry.hasta,
  );

  return {
    id: idCandidate ? String(idCandidate) : `horario-${index}`,
    name: nombreCandidate ? String(nombreCandidate) : '',
    startTime: inicioCandidate ? String(inicioCandidate) : '',
    endTime: finCandidate ? String(finCandidate) : '',
    isCustom: Boolean(entry.isCustom),
  };
};

export const normalizeHorariosList = (...sources) => {
  const aggregated = [];
  const seen = new Set();

  sources.forEach((source) => {
    ensureArray(source).forEach((item, index) => {
      const normalized = normalizeHorarioEntry(item, aggregated.length + index);
      const key = normalizeTurnoId(normalized.id) || `horario-${aggregated.length + index}`;
      if (seen.has(key)) {
        return;
      }
      seen.add(key);
      aggregated.push({
        ...normalized,
        id: key,
      });
    });
  });

  return aggregated;
};

export const loadHorariosFromStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) return [];
  try {
    const raw = window.localStorage.getItem(SCHEDULES_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return normalizeHorariosList(parsed);
  } catch (_) {
    return [];
  }
};

export const prepareHorariosForStorage = (collection) => {
  if (!Array.isArray(collection)) return [];
  return collection.map((item, index) => {
    const normalized = normalizeHorarioEntry(item, index);
    return {
      id: normalizeTurnoId(normalized.id) || `horario-${index}`,
      name: normalized.name,
      startTime: normalized.startTime,
      endTime: normalized.endTime,
      isCustom: item?.isCustom ? true : undefined,
    };
  });
};

export const saveHorariosToStorage = (collection) => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    const sanitized = prepareHorariosForStorage(collection).filter((item) => {
      return item.name || item.startTime || item.endTime;
    });

    if (sanitized.length === 0) {
      window.localStorage.removeItem(SCHEDULES_STORAGE_KEY);
      return;
    }

    window.localStorage.setItem(SCHEDULES_STORAGE_KEY, JSON.stringify(sanitized));
  } catch (_) {
    // Ignoramos errores de almacenamiento
  }
};